// extracted by mini-css-extract-plugin
export default {"section":"SectionTemplate_section__72pXw","container":"SectionTemplate_container__a3rQC"};